export default (theme: any) => ({
    button: {
        width: '50%',
        marginTop: '30px',
        [theme.breakpoints.between('xs', 'lg')]: {
            minWidth: '100%',
            marginTop: '10px',
        },
    },

    paper: {
        padding: theme.spacing(2),
        textAlign: 'center',
        color: theme.palette.text.secondary,
        borderRadius: '2px',
        '& h4': {
            textAlign: 'left',
        },
        '& h5': {
            textAlign: 'left',
        },
    },
})
